import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=78c836f8&scoped=true&"
import script from "./MediaDetail.vue?vue&type=script&lang=js&"
export * from "./MediaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c836f8",
  null
  
)

export default component.exports